export default "__VITE_ASSET__CpP_kLQz__"